import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dealeri-verificati/")({
  head: () => routeHead("/de/dealeri-verificati/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/verified-dealers", statusCode: 301, replace: true });
  },
});
